import { Fragment } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { VscLoading } from 'react-icons/vsc';
import { useSelector } from 'react-redux';
import { toNepaliNumber } from '../../../../../_helpers/_methods';

function ReportInfoCard({ titleId, loading, count, Icon, iconColor, action }) {
  const local = useSelector((state) => state.local.local);
  return (
    <div className="px-2 pt-3">
      <div className="d-flex">
        <div> {Icon && <Icon fontSize="2rem" className="me-2" color={iconColor} />}</div>
        <h3 className="me-3 font-weight-bold">
          {!isNaN(count) ? (
            <Fragment>
              {loading ? (
                <VscLoading className="spin small" />
              ) : local === 'ne' ? (
                toNepaliNumber(count)
              ) : (
                count
              )}
            </Fragment>
          ) : (
            <VscLoading className="spin small" />
          )}
          {action && (
            <Button
              variant="outline-info"
              className="btn btn-sm btn-outline-info ms-3"
              onClick={action}>
              <FormattedMessage id="button.seeAll" />
            </Button>
          )}
        </h3>
      </div>
      <h5 className="mt-3 text-secondary">
        <FormattedMessage id={titleId} />
      </h5>
    </div>
  );
}

export default ReportInfoCard;
